import { api } from './api';
const list = (input) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/team'}, input);
}
const eidt = (input, team_id) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/team/'+team_id+'/edit'}, input);
}

export const teamService = {
	list,
  eidt
};